import React from 'react';
import { Icon } from 'semantic-ui-react';
import { stringToCheck } from '@/utils/resultsHelper';
import { announcementLevels } from '../constants';

const AnnouncementIcon = ({ level }) => (
  <Icon
    className="f-20 mr-10 mt-10"
    name={announcementLevels[stringToCheck(level).toLowerCase()] || announcementLevels.information}
    size="tiny"
  />
);

export default AnnouncementIcon;
